import { Droppable, Draggable } from "@hello-pangea/dnd";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { ReactComponent as DeleteIcon } from "../../assets/images/icons/FadeDelete.svg";
import BasicSelect from "../Task/BasicSelect";
import { ReactComponent as IsLock } from "../../assets/images/icons/IsLock.svg";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import { truncateString } from "../../utils/utilityFunctions/stringUtility";
import { useState } from "react";
import InputComponent from "../UniversalComponents/InputComponent";

const Section = ({
  section,
  is_locked,
  index,
  onEditSection,
  onDeleteSection,
  onEditInput,
  onDeleteInput,
  getAllFunnel,
  selectedfunnel,
  setSelectedFunnel,
  isDeployed,
  templateId,
  handleEditSection,
}) => {
  let is_itemDeploy = Boolean(isDeployed);
  const [editsection, setEditSection] = useState(false);
  const [sectionName, setSectionName] = useState(section?.sectionName);
  return (
    <>
      {console.log(section, "hiemgeopmgermgpem")}

      <Draggable draggableId={section.sectionId} index={index} isDragDisabled={is_locked || is_itemDeploy}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`mb-4 rounded overflow-x-hidden ${is_locked && "bg-[#004EFF0F]"} ${(is_itemDeploy || is_locked) && "cursor-not-allowed"}  `}
          >
            <div className="flex justify-start items-center border-b group h-10">
              <h3
                {...provided.dragHandleProps}
                className={`font-semibold flex items-center gap-2 ${
                  is_itemDeploy ? "cursor-not-allowed opacity-80" : "cursor-none"
                }`}
              >
                {editsection ? (
                  <InputComponent
                    value={sectionName}
                    onChange={(e) => setSectionName(e.target.value)}
                    onBlur={() => setEditSection(false)}
                    autoFocus
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleEditSection({
                          sectionId: section.sectionId,
                          sectionName: sectionName && sectionName,
                          templateId: templateId,
                        });
                        setEditSection(false);
                      }
                    }}
                    placeholder="Section Name"
                    className="w-1/2"
                  />
                ) : (
                  <span className="text-[#0c0c0cda] text-base mx-2">{sectionName}</span>
                )}

                {section.sectionName === "Funnel Information" && (
                  <span className="text-orange-400 font-normal text-xs mr-1 mb-1">Update the funnel accordingly.</span>
                )}
              </h3>
              <span className="mr-3 mb-1">{is_locked && <IsLock />}</span>
              {!section?.is_locked && (
                <div className="group-hover:flex hidden">
                  {!editsection && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setEditSection(true);
                        // onEditSection(section);
                      }}
                      disabled={is_itemDeploy}
                    >
                      <EditIcon className="text-indigo-700" fontSize="small" />
                    </IconButton>
                  )}
                  <IconButton size="small" onClick={() => onDeleteSection(section.sectionId)} disabled={is_itemDeploy}>
                    <DeleteIcon className="fill-[#F8454599] hover:fill-[#F84545]" fontSize="small" />
                  </IconButton>
                </div>
              )}
            </div>
            <Droppable droppableId={section.sectionId} type="INPUT" isDropDisabled={is_itemDeploy || is_locked}>
              {(provided, snapshot) => {
                const isDraggingOver = snapshot.isDraggingOver;
                return (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={`max-h-[30.5vh] grid grid-cols-2 gap-2 p-2 thinscrollbar rounded-md overflow-auto ${is_locked && "bg-[#004cff02]"} ${
                      is_itemDeploy && "cursor-not-allowed"
                    }
                  ${isDraggingOver ? "bg-indigo-50 border-2 border-indigo-400" : " border border-transparent"}
                  `}
                  >
                    {section?.inputs?.map((input, idx) => (
                      <Draggable
                        key={input.inputId}
                        isDragDisabled={is_itemDeploy || is_locked}
                        draggableId={input.inputId}
                        index={idx}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`flex  w-full bg-primary-hover group border border-[#DFE2E5]  items-center  ${
                              is_itemDeploy ? "cursor-not-allowed opacity-80" : ""
                            }`}
                          >
                            {section.sectionName === "Funnel Information" ? (
                              <BasicSelect
                                options={getAllFunnel?.map((eachItem) => ({
                                  label: eachItem?.funnel_name,
                                  value: eachItem?.id,
                                }))}
                                selectedOptions={
                                  selectedfunnel?.value
                                    ? getAllFunnel
                                        ?.filter((option) => option.id === selectedfunnel?.value)
                                        ?.map((eachItem) => ({
                                          label: eachItem?.funnel_name,
                                          value: eachItem?.id,
                                        }))
                                    : getAllFunnel?.length > 0
                                      ? [
                                          {
                                            label: getAllFunnel[0]?.funnel_name,
                                            value: getAllFunnel[0]?.id,
                                          },
                                        ]
                                      : []
                                }
                                // Match the selectedfunnel.target.value with the options
                                onChange={(selectedOption) => {
                                  setSelectedFunnel(selectedOption?.target);
                                }}
                                disabled={is_itemDeploy}
                              />
                            ) : (
                              <>
                                <p className="w-1/4 text-[#131313CC]/80 font-Inter font-normal bg-[#004cff0a] text-sm px-4 py-2.5 truncate">
                                  {truncateString({ str: input.inputValue })}
                                </p>

                                <div className="flex min-w-0 grow h-10 justify-between items-center  p-2 bg-white">
                                  <div>
                                    <span className="px-3 py-1 text-[#13131399]/60 font-Inter font-normal text-sm">
                                      {input?.inputType}
                                    </span>
                                    {/* <span className="p-2 rounded-full bg-green-500">tm</span> */}
                                  </div>
                                  {!is_locked && (
                                    <div className="ml-1 group-hover:flex hidden group">
                                      <IconButton
                                        size="small"
                                        onClick={() => onEditInput(section?.sectionId, section?.sectionName, input)}
                                        disabled={is_itemDeploy}
                                      >
                                        <EditIcon className="text-indigo-700" fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        size="small"
                                        onClick={() => onDeleteInput(section.sectionId, input.inputId)}
                                        disabled={is_itemDeploy}
                                      >
                                        <DeleteIcon
                                          className="fill-[#F8454599] hover:fill-[#F84545]"
                                          fontSize="small"
                                        />
                                      </IconButton>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </div>
        )}
      </Draggable>
    </>
  );
};

export default Section;
